module.exports = __webpack_public_path__ + "static/img/wechatcode.fcd6e8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wechatcode.jpg
// module id = 9
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14